import React, { useState } from 'react';
import YoufeedStar from './YoufeedStar';
import { useAppContext } from '../../../Store/Store';

interface StarRatingProps {
  rating: number;
  setRating: (value: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({ rating, setRating }) => {
  const [hover, setHover] = useState<number | null>(null);
  const { style } = useAppContext();

  return (
    <div style={{ display: 'flex', marginTop: '10px' }}>
      {[1, 2, 3, 4, 5].map(star => {
        const isActive = star <= (hover ?? rating);
        return (
          <div
            key={star}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(null)}
            onClick={() => setRating(star)}
            style={{
              cursor: 'pointer',
              width: '46px',
              height: '45px',
              transition: 'fill 200ms',
              color: isActive ? style.stars_base_color : style.stars_base_color,
            }}
          >
            <YoufeedStar
              style={{ width: '100%', height: '100%' }}
              gradient={
                isActive
                  ? {
                      gradient1: style.stars_gradient1_color,
                      gradient2: style.stars_gradient2_color,
                    }
                  : undefined
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default StarRating;
